<template>
  <CreateSave
      :maxWidth="500"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :createData="createData"
      @onCreate="(response) => $emit('onCreate', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.subject"
              :error-messages="errors.subject"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Predmet"
          />
        </v-col>
      </v-row>
    </template>
  </CreateSave>
</template>

<script>
  import Tickets from '@/services/tickets'

  import CreateSave from '@/components/_Part/_Modal/_Save/Create'

  export default {
    name: 'Create',
    emits: [
      'onCreate'
    ],
    components: {
      CreateSave
    },
    data() {
      return {
        files: []
      }
    },
    methods: {
      setTitle() {
        return 'Vytvoriť tiket'
      },
      setItemForm() {
        this.files = []

        return {
          subject: null
        }
      },
      createData(ItemForm) {
        return Tickets
          .create({
            data: ItemForm
          })
      }
    }
  }
</script>
